import React from 'react';
import { siteTitle } from 'site.config';

const { NEXT_PUBLIC_SITE_URL } = process.env;

const SData = ({ article }) => {
  const link = `${NEXT_PUBLIC_SITE_URL}/posts/${article.id}/`;
  const siteSchema = {
    '@context': 'http://schema.org',
    '@type': 'WebSite',
    url: link,
    name: siteTitle,
    description: article.summary,
    inLanguage: 'en',
    image: article.cover,
  };

  const breakcrumbSchema = {
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        item: {
          '@id': NEXT_PUBLIC_SITE_URL,
          name: siteTitle,
        },
      },
      {
        '@type': 'ListItem',
        position: 2,
        item: {
          '@id': link,
          name: article.title,
        },
      },
    ],
  };

  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': link,
    },
    headline: article.title,
    image: {
      '@type': 'ImageObject',
      url: article.cover,
    },
    datePublished: article.created_at,
    dateModified: article.updated_at,
    author: {
      '@type': 'Person',
      name: 'Admin',
    },
    publisher: {
      '@type': 'Organization',
      name: siteTitle,
      logo: {
        '@type': 'ImageObject',
        url: `${NEXT_PUBLIC_SITE_URL}/images/big_logo.png`,
      },
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(siteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breakcrumbSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(articleSchema) }}
      />
    </>
  );
};
export default SData;
